import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { localStorageJson } from 'ngx-mt-ui-lib/extensions/local-storage-json';
import {
  RUNTIME_CONFIG,
  validateRuntimeConfig,
} from './app/core/config/runtime-config';

localStorageJson();

async function start(): Promise<void> {
  const response = await fetch('/runtime-config.json', { cache: 'no-store' });
  if (!response.ok)
    throw new Error('Не удалось загрузить конфигурацию приложения');
  const config = validateRuntimeConfig(await response.json(), location.origin);
  await bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [
      ...appConfig.providers,
      { provide: RUNTIME_CONFIG, useValue: config },
    ],
  });
}

void start().catch(() => {
  const root = document.querySelector('app-root');
  if (root)
    root.textContent =
      'Не удалось запустить приложение. Проверьте соединение и обновите страницу.';
});
